export default __webpack_public_path__ + "static/media/Sword of Scarlet Fire.68c1b58e.jpg";